import { render, staticRenderFns } from "./TuxhornEthermP_4d00.vue?vue&type=template&id=dba4d69e&"
import script from "./TuxhornEthermP_4d00.vue?vue&type=script&lang=js&"
export * from "./TuxhornEthermP_4d00.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports